import dayjs from 'dayjs'
import 'dayjs/locale/fr'

dayjs.locale('fr')

export function formatDate(datetime, options = {}) {
  return new Intl.DateTimeFormat('fr-FR', options).format(new Date(datetime))
}

export function formatDateTime(datetime, options = {}) {
  return new Intl.DateTimeFormat('fr-FR', { ...options, dateStyle: 'short', timeStyle: 'short' }).format(new Date(datetime))
}

export function formatDuration(count, unit) {
  if (unit !== 'month' && count > 1) unit += 's'
  unit = unit.replace('day', 'jour').replace('week', 'semaine').replace('month', 'mois').replace('year', 'an')
  return `${count} ${unit}`
}

export function formatRelativeDate(date) {
  if (dayjs().isSame(date, 'day')) return dayjs(date).format('H:mm').split(':').join('h')
  else if (dayjs().subtract(1, 'day').isSame(date, 'day')) return 'hier à ' + dayjs(date).format('H') + 'h'
  else if (dayjs().subtract(7, 'day').isBefore(date)) return dayjs(date).format('dddd à H') + 'h'
  return dayjs(date).format('DD/MM/YYYY')
}

// Calendar utilities
export const DAYS_OF_WEEK = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim']

export const MONTHS = [
  'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
  'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
]

// Return for example Janvier-Février if the current week is in both months
// Return for example Janvier if the current week is in only one month
export function currentMonths(date) {
  const weekStart = dayjs(date).startOf('week')
  const weekEnd = dayjs(date).endOf('week')

  const monthStart = weekStart.month()
  const monthEnd = weekEnd.month()

  if (monthStart === monthEnd) {
    return MONTHS[monthStart]
  } else {
    return `${MONTHS[monthStart]}-${MONTHS[monthEnd]}`
  }
}

export function formatTimeRange(start, end) {
  const startTime = dayjs(start).format('HH:mm')
  const endTime = dayjs(end).format('HH:mm')
  return `${startTime} - ${endTime}`
}

export function getStartOfDay(date) {
  return dayjs(date).startOf('day').toDate()
}

export function getEndOfDay(date) {
  return dayjs(date).endOf('day').toDate()
}
